import Empty from "@/components/common/Empty.vue";
import OrderDeliveryTile from "@/components/order/sections/OrderDeliveryTile.vue";
import OrderDetails from "@/components/order/sections/OrderDetails.vue";
import OrderItems from "@/components/order/sections/OrderItems.vue";
import OrderStatus from "@/components/order/sections/OrderStatus.vue";
import OrderPayDetail from "@/components/order/sections/OrderPayDetail.vue";
import OrderBillDetail from "@/components/order/sections/OrderBillDetail.vue";
import OrderRefundDetail from "@/components/order/sections/OrderRefundDetail.vue";

import { getRefundAmounts } from "@/utils";
import { mapState } from "vuex";
import DepositOrderDetails from "@/components/order/sections/DepositOrderDetails.vue";
import DepositOrderItems from "@/components/order/sections/DepositOrderItems.vue";
import CBottomPad from "@/components/common/CBottomPad.vue";
import CConfirm from "@/components/common/CConfirm.vue";

export default {
  components: {
    Empty,
    OrderStatus,
    OrderDeliveryTile,
    OrderItems,
    OrderDetails,
    OrderPayDetail,
    OrderBillDetail,
    OrderRefundDetail,
    DepositOrderDetails,
    DepositOrderItems,
    CBottomPad,
    CConfirm,
  },
  data() {
    return {
      loaded: false,
      order: {},
      hasOrderPermission: true,
      submiting: false,
    };
  },
  computed: {
    ...mapState(["brandInfo"]),
    amount() {
      return this.order.amount;
    },
    isBaseOrder() {
      return this.order.type === 1;
    },
    isStatusPaid() {
      // return true;
      return (
        (this.order.status > 10 && this.order.status < 70) ||
        this.order.status === 80
      );
    },
    isStatusSent() {
      return (
        this.isBaseOrder &&
        [50, 60].includes(this.order.status) &&
        this.order.deliveryMethod === 0
      );
    },
    hasPayData() {
      return this.isStatusPaid && this.order.orderPayLogVos?.length > 0;
    },
    computedRefundStatus() {
      const amounts = getRefundAmounts(this.order);
      // console.log("RefundAmounts", amounts);
      const isRefunding = this.isStatusPaid && amounts.refundingAmount > 0;
      const isRefundAll =
        this.isStatusPaid && amounts.refundedAmount === this.amount;
      return {
        ...amounts,
        isRefunding,
        isRefundAll,
        isRefundingOrDone: isRefunding || isRefundAll,
      };
    },
    refundSections() {
      if (this.isStatusPaid && this.order.orderRefundVos?.length > 0) {
        return this.order.orderRefundVos;
      }
      return [];
    },

    hasBill() {
      return (
        this.order.status > 10 &&
        this.order.status < 70 &&
        this.order.bill &&
        !!this.order.billVo
      );
    },
  },
  async mounted() {
    try {
      console.log("order-page mounted");
      this.loading("加载中");
      await this.updateOrderDetail();
      this.loading(false);
    } catch (error) {
      if (error?.message) this.$toast(error.message);
      else this.loading();
    }
  },
  activated() {
    console.log("order-page activated");
  },
  methods: {
    /**
     *
     * @param { string | false } message
     */
    loading(message = "") {
      // NOSONAR 这里的取值就是可以是 字符串 或 false
      if (message !== false) {
        this.$toast.loading({
          message,
          forbidClick: true,
        });
      } else {
        this.$toast.clear();
      }
    },
    setSubmitting(message = "") {
      this.submiting = true;
      this.loading(message || "");
    },
    unsetSubmitting(message = "") {
      this.submiting = false;
      if (message) this.$toast(message);
      else this.loading(false);
    },
    async alert(message) {
      try {
        await this.$refs.refCConfirm.show(message);
        return true;
      } catch (error) {
        return false;
      }
    },
    checkOrderPermission(error) {
      console.log("updateOrderDetail error", error);
      if (error.code == "3024") {
        this.hasOrderPermission = false;
      } else {
        return Promise.reject(error);
      }
    },
    async onTimeup() {
      try {
        this.setSubmitting();
        await this.updateOrderDetail();
        this.unsetSubmitting();
      } catch (error) {
        this.unsetSubmitting(error?.message);
      }
    },
  },
};
